import { render, staticRenderFns } from "./ListSpecimenModal.vue?vue&type=template&id=43b35e0a"
import script from "./ListSpecimenModal.vue?vue&type=script&lang=js"
export * from "./ListSpecimenModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports